import type { ModuleRoute } from '../types';
import { DisplayApp } from './DisplayApp';
import { ManageDisplaysPage } from './ManageDisplaysPage';

/**
 * Pages of this area: the reception display app (/display, public: no shell and no sign-in; it pairs with a code and then holds
 * a device token) and Manage -> Reception displays. Owned by Phase 3 task W22; only that task edits files in this folder (W23 wires it last).
 * The display host (display.cloudsign.uk) redirects its `/` to `/display`.
 */
export const routes: ModuleRoute[] = [
  { path: '/display', element: <DisplayApp />, public: true, area: 'any' },
  { path: '/manage/displays', element: <ManageDisplaysPage />, permission: 'displays.view' },
];
